<template>
  <div class="view pa24">
    <div>
      <el-select v-model="value" value-key :placeholder="$t('addedServices', 'pleaseSelect')" @change="optionChange">
        <el-option
          v-for="(item,index) in options"
          :key="index"
          :label="item.value"
          :value="item.lable"
        >
        </el-option>
      </el-select>
      <!-- <el-button class="ml10" type="primary">{{ $t('addedServices', 'export') }}</el-button> -->
    </div>
    <commonTable :tableData="tableData"
                 @handleSizeChange="handleSizeChange"
                 @handleCurrentChange="handleCurrentChange"
                 :currentPage="currentPage"
                 :loading="loading"
                 :total="total">
      <template v-slot:table>
        <el-table-column
          type="index"
          align="center"
          :label="$t('addedServices', 'number')"
          show-overflow-tooltip
        />
        <el-table-column prop="name" align="center" :label="$t('addedServices', 'name')" />
        <el-table-column prop="phone" align="center" :label="$t('addedServices', 'mobilePhone')" />
        <el-table-column prop="clockDay" align="center" :label="$t('addedServices', 'totalClockDays')" />
        <el-table-column prop="firstTime" align="center" :label="$t('addedServices', 'firstClockTimeLabel')" />
        <el-table-column align="center" :label="$t('addedServices', 'operation')">
          <template slot-scope="scope">
            <el-button type="text" @click="detail(scope.row)">{{ $t('addedServices', 'detail') }}</el-button>
          </template>
        </el-table-column>
      </template>
    </commonTable>
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import i18nMixin from '@/mixins/i18nMixin';
import {
  queryPageUserClock
} from "@/api/addedServices";

export default {
  mixins: [i18nMixin],
  data() {
    return {
      value:'',
      options:[
        {lable:'1',value: this.$t('addedServices', 'totalClockDaysHighToLow')},
        {lable:'2',value: this.$t('addedServices', 'totalClockDaysLowToHigh')},
      ],
      tableData: [],
      loading:false,
      currentPage: 1, //当前页数
      total: 0, //总条数
      pageNum:1,
      pageSize:10,
      dayNum:1
    };
  },
  components: {
    commonTable,
  },
  created(){
    this.getTableData()
  },
  methods:{
    optionChange(val){
      this.dayNum =  val
      this.getTableData()
    },
    async getTableData() {
      this.loading = true
      let data = {
        pageNum: this.pageNum,
        pageSize:this.pageSize,
        type : this.dayNum
      };
      const result = await queryPageUserClock(data);
      this.loading = false
      if(result.data){
        this.tableData = result.data.pageInfo.list;
        this.total = result.data.pageInfo.total
        this.tableData.forEach(v=>{
          v.imagesList = [];
          v.imagesList.push(v.logo);
        })
      }else{
        this.tableData = []
      }
    },
    handleCurrentChange(num) {
      this.pageNum = num;
      this.getTableData();
    },
    detail(row){
      this.$router.push({ path:`/clockDataDetall?clockId=${row.clockId}` });
    },
    //当前页查询数据条数变更
    handleSizeChange(num) {
      this.pageSize = num;
      this.pageNum = 1;
      this.currentPage = 1;
      this.getTableData();
    },
  }
};
</script>

<style lang="scss" scoped>
</style>